import HotelTitle from './HotelTitle.component';
export default HotelTitle;